import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {VisitaServices} from '../services/visita.services';
import {VisitaModel} from '../models/visita.model';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import * as moment from 'moment';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {CategoriaModel, SubcategoriaModel} from '../models/categoria.model';
import {PreguntaModel} from '../models/pregunta.model';
import {ResultadoModel} from '../models/resultado.model';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap';
import {Subscription} from 'rxjs';
import {PdfServices} from '../../CoreModule/services/pdf.services';
import {VIEWIMAGERVG} from '../../variables';
import {DecimalPipe} from '@angular/common';
import {PlantillasServices} from '../services/plantillas.services';
import {PlantillaModel} from '../models/plantilla.model';

@Component({
  selector: 'edit-visita',
  templateUrl: '../templates/visitas/edit.visita.template.html'
})
export class EditVisitaComponent implements OnInit, OnDestroy {

  visita: VisitaModel;

  lstCategorias: CategoriaModel[] = [];

  lstSubcategoria: SubcategoriaModel[] = [];

  lstPreguntas: PreguntaModel[] = [];
  lstResultados: ResultadoModel[] = [];

  @ViewChild('modalVisita', {static: true})
  templateModal: TemplateRef<any>;

  @ViewChild('modalError', {static: true})
  templateError: TemplateRef<any>;

  modalRef: BsModalRef;

  onSendVisita: Subscription;
  onSendEncabezado: Subscription;

  formulario: any = {
    categorias: []
  };

  constructor(private vs: VisitaServices, private ar: ActivatedRoute, private router: Router, private spinner: NgxSpinnerService, private ms: BsModalService) {
  }

  ngOnInit(): void {
    let id = this.ar.snapshot.params.id;
    this.spinner.show();

    this.onSendEncabezado = this.vs.obsSaveEncabezado.subscribe(d => {
      // console.log(d);
    });

    this.onSendVisita = this.vs.obsSendVisita.subscribe(d => {

      this.visita = d.visita;
      this.visita.fechaCreacion = moment(this.visita.fechaCreacion).format('DD-MM-YYYY HH:mm:ss');
      this.visita.fechaInicio = moment(this.visita.fechaInicio).format('DD-MM-YYYY HH:mm:ss');


      // comprobar si esta abierta, si esta cerrada se redirige a la vista de solo lectura
      if (this.visita.estado == 1)
        this.router.navigate(['/visitas/view', id]);

      this.lstPreguntas = d.preguntas;
      this.lstResultados = d.visita.resultados;

      this.formulario.categorias = [];


      let indice = 1;
      this.visita.plantilla.catActivas.map(c => {

        c.indice = indice;
        c.indiceActual = 1;
        c.subcategorias = [];
        this.formulario.categorias.push(c);
        indice++;
      });


      this.visita.plantilla.subcatActivas.map(s => {
        let cat = this.formulario.categorias.find(c => c.id == s.categoria);


        let preguntas = this.lstPreguntas.filter(p => {
          return p.subcategoria._id == s.id;
        });

        preguntas.map(p => {
          let result = this.lstResultados.find(r => r.pregunta == p._id);
          p.resultado = result;
        });

        s.preguntas = preguntas;

        if (cat) {
          s.indice = cat.indiceActual;
          cat.subcategorias.push(s);
          cat.indiceActual++;
        }


      });

      // console.log(this.formulario);

      this.spinner.hide();
    });

    this.vs.obsVisCerrada.subscribe(d => {
      this.spinner.hide();
      this.openModal((d == 1));
      if (d == 1)
        this.router.navigate(['/visitas/view', id]);
    });

    this.vs.getVisita(id);

  }

  actualizarEncabezados() {
    // console.log(this.visita.fechaVisita);
    this.vs.saveEncabezado(this.visita);
  }


  ngOnDestroy(): void {
    if (this.onSendVisita)
      this.onSendVisita.unsubscribe();

    if (this.onSendEncabezado)
      this.onSendEncabezado.unsubscribe();
  }

  finalizarVisita() {

    let pregResponder: any = {
      abierta: false
    };

    this.lstResultados.map(r => {
      if (r.respuesta == undefined) {
        pregResponder.abierta = true;
        pregResponder.preg = this.lstPreguntas.find(p => p._id == r.pregunta);
      }
    });

    if (pregResponder.abierta) {
      alert(`Falta por responder la pregunta ${pregResponder.preg.indice}. ${pregResponder.preg.enunciado}`);
      return;
    }

    if (this.visita.fechaVisita == '') {
      alert(`Falta ingresar la fecha en la que se realizo la visita en el encabezado del formato`);
      return;
    }

    this.vs.saveEncabezado(this.visita);

    this.visita.estado = 1;

    this.spinner.show();
    this.vs.finalizarVisita(this.visita._id);

  }

  openModal(isFine: boolean) {

    if (isFine)
      this.modalRef = this.ms.show(this.templateModal);
    else
      this.modalRef = this.ms.show(this.templateError);


    setTimeout(() => {
      this.modalRef.hide();
      // redireccionar
    }, 3000);
  }

}


@Component({
  selector: 'visita-view',
  templateUrl: '../templates/visitas/visita.template.html',
  styleUrls: ['../styles/rvg.styles.scss']
})
export class VisitaComponent implements OnInit, OnDestroy {

  visita: VisitaModel;

  calificacionTotal: number = 0;

  @ViewChild('lightbox', {static: true})
  templateModal: TemplateRef<any>;

  modalRef: BsModalRef;

  formulario: any = {
    categorias: []
  };

  lstPreguntas: PreguntaModel[] = [];
  lstResultados: ResultadoModel[] = [];

  onSendVisita: Subscription;

  pathServerFoto: string = '';

  imgSelectLightbox: string = '';

  constructor(private vs: VisitaServices, private ar: ActivatedRoute, private router: Router,
              private spinner: NgxSpinnerService, private ps: PdfServices, private ms: BsModalService, private dp: DecimalPipe) {
  }

  ngOnInit(): void {

    let id = this.ar.snapshot.params.id;
    this.pathServerFoto = VIEWIMAGERVG;
    this.spinner.show();

    this.onSendVisita = this.vs.obsSendVisita.subscribe(d => {


      this.visita = d.visita;

      this.visita.fechaCreacion = moment(this.visita.fechaCreacion).format('DD-MM-YYYY HH:mm:ss');
      this.visita.fechaInicio = moment(this.visita.fechaInicio).format('DD-MM-YYYY HH:mm:ss');
      this.visita.fechaFin = moment(this.visita.fechaFin).format('DD-MM-YYYY HH:mm:ss');


      if (this.visita.estado != 1)
        this.router.navigate(['/visitas']);

      this.lstPreguntas = d.preguntas;
      d.visita.resultados.map(r => {
        this.lstResultados.push(ResultadoModel.newResultado(r));
      });




      this.visita.calificacion.map(c => {
        this.calificacionTotal += c.calificacion / (c.cantPreg - c.totalNA) * c.porcentaje;
      });

      let indice = 1;
      this.visita.plantilla.catActivas.map(c => {
        c.indice = indice;
        c.indiceActual = 1;
        c.subcategorias = [];
        c.calificacion = this.visita.calificacion.find(cal => cal.categoria == c.nombre);

        this.formulario.categorias.push(c);
        indice++;

      });

      this.visita.plantilla.subcatActivas.map(s => {
        let cat = this.formulario.categorias.find(c => c.id == s.categoria);


        let preguntas = this.lstPreguntas.filter(p => {
          return p.subcategoria._id == s.id;
        });

        preguntas.map(p => {
          let result = this.lstResultados.find(r => r.pregunta == p._id);
          let fotos = this.visita.fotos.filter(f => f.pregunta == p._id);

          if (fotos.length > 0)
            result.fotos = fotos;
          p.resultado = result;
        });


        s.preguntas = preguntas;

        if (cat) {
          s.indice = cat.indiceActual;
          cat.subcategorias.push(s);
          cat.indiceActual++;
        }

        let indice = 1;
        preguntas.map(p => {
          p.indice = `${cat.indice}.${s.indice}.${indice}`;
          indice++;
        });

        this.spinner.hide();



      });

      console.log(this.visita.plantilla.subcatActivas)
    });

    this.vs.getVisita(id);
  }

  imagenSelect(path: string) {
    this.imgSelectLightbox = path;
    this.modalRef = this.ms.show(this.templateModal, Object.assign({}, {class: 'modal-lg'}));
  }

  generarPdf() {

    let docDefinition: any = {
      content: []
    };

    // titulo
    docDefinition.header = {text: 'FORMATO DE REVISIÓN VISITA GERENTE - RVG', alignment: 'center', margin: [0, 5]};

    // encabezado
    docDefinition.content.push({
      columns: [
        {
          style: 'encabezado',
          table: {
            body: [
              ['Tienda', this.visita.tienda.nombre],
              ['Fecha Inicio', this.visita.fechaInicio],
              ['Fecha Cierre', this.visita.fechaFin],
              ['Lider', this.visita.lider],

            ]
          }
        },
        {
          style: 'encabezado',
          table: {
            body: [
              ['Consultores', this.visita.consultora],
              // ['Consultor', this.visita.consultor],
              ['Clientes en la Tienda', this.visita.clientesEnTienda],
              ['Gerente', this.visita.gerente]
            ]
          }
        },
        {
          style: 'encabezado',
          table: {
            body: this.devolverPuntacionPdf()
          }
        }
      ]
    });


    docDefinition.styles = {
      encabezado: {
        fontSize: 9,
        margin: [0, 0, 0, 10]
      },

      tables: {
        fontSize: 9
      },
      secCategoria: {
        fillColor: '#b6b9bc',
        bold: true
      },

      secSubCat: {
        fillColor: '#2ffffd',
        bold: true
      },

      rSi: {
        color: '#26a69a',
        bold: true
      },
      rNo: {
        color: '#FF0000',
        bold: true
      },
      rNA: {
        color: '#c9cc0a',
        bold: true
      }


    };

    //categorias
    for (let c of this.formulario.categorias) {
      docDefinition.content.push(this.convertirCategoriaPdf(c));
    }

    docDefinition.content.push({text: 'Observaciones Finales:'});
    docDefinition.content.push({text: this.visita.observacionesGenerales});


    this.ps.generarPdf(docDefinition);

  }

  devolverPuntacionPdf() {
    let puntuacion: any[] = [];

    for (let c of this.visita.calificacion) {
      puntuacion.push([c.categoria, this.dp.transform(c.calificacion / (c.cantPreg - c.totalNA) * 100, '0.1-2') + '%']);
    }

    puntuacion.push(['Total', this.dp.transform(this.calificacionTotal, '0.1-2') + '%']);

    return puntuacion;
  }

  convertirCategoriaPdf(cat: any) {
    let dataC: any = {};

    dataC.style = 'tables';
    dataC.table = {
      widths: ['auto', 20, 200],
      body: [
        [{colSpan: 3, text: `${cat.indice}. ${cat.nombre}`, style: 'secCategoria'}, '', '']
      ]
    };

    for (let s of cat.subcategorias) {
      dataC.table.body.push([{colSpan: 2, text: `${cat.indice}.${s.indice}. ${s.nombre}`, style: 'secSubCat'}, '', {
        text: 'Observaciones',
        style: 'secSubCat'
      }]);

      for (let p of s.preguntas) {
        let dtPreg: any[] = [];
        dtPreg.push({text: `${p.indice} ${p.enunciado}`});
        dtPreg.push({text: p.resultado.devolverResStr(), alignment: 'center', style: p.resultado.devolverClase()});
        dtPreg.push(p.resultado.observacion);
        dataC.table.body.push(dtPreg);
      }
    }

    return dataC;
  }

  ngOnDestroy(): void {
    if (this.onSendVisita)
      this.onSendVisita.unsubscribe();
  }

}

@Component({
  selector: 'lista-visita',
  templateUrl: '../templates/visitas/list.visita.template.html'
})
export class ListVisitasComponent implements OnInit {

  lstVisitas: VisitaModel[] = [];

  ano: number;
  bimestre: any;
  plantillaFiltro: any;
  nombreFiltro: any;

  rows: any[] = [];
  public tempFullRows: any[] = [];

  public lstPlantillas: PlantillaModel[] = [];

  columns = [
    {name: 'Tienda'},
    {name: 'Fecha'},
    {name: 'plantilla'},
    {name: 'Estado'},
    {name: 'Acciones'}
  ];


  constructor(private vs: VisitaServices, private ps: PlantillasServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();

    this.ps.getAllPlantillas().subscribe((d: any) => {
      this.lstPlantillas = d.data.plantillas.filter(p=> p.activo);;

    });

    this.vs.getAllVisitas().subscribe((d: any) => {

      if (d.data.visitasUsuario.length < 0) {
        this.spinner.hide();
        return;
      }

      this.lstVisitas = d.data.visitasUsuario;

      for (let v of this.lstVisitas) {

        let fecha = moment(v.fechaCreacion);
        this.rows.push({
          tienda: v.tienda.nombre,
          fecha: fecha.format('DD-MM-YYYY'),
          plantilla: v.plantilla.nombre,
          estado: (v.estado == 1) ? 'Cerrado' : 'Abierto',
          mes: fecha.month(),
          ano: fecha.year(),
          id: v._id,
          acciones: v
        });

        this.tempFullRows.push({
          tienda: v.tienda.nombre,
          fecha: fecha.format('DD-MM-YYYY'),
          plantilla: v.plantilla.nombre,
          estado: (v.estado == 1) ? 'Cerrado' : 'Abierto',
          mes: fecha.month(),
          ano: fecha.year(),
          id: v._id,
          acciones: v
        });
      }

      this.rows = [...this.rows];
      this.spinner.hide();
    });
  }

  filtrarTiendas(event) {

    let val = event.target.value.toLowerCase();

    this.nombreFiltro = val;

    let temp;

    if (this.ano == undefined || this.bimestre == undefined)
      temp = this.tempFullRows.filter(t => t.tienda.toLowerCase().indexOf(val) !== -1 || !val);
    else {
      temp = this.aplicarFiltros();
      temp = temp.filter(t => t.tienda.toLowerCase().indexOf(val) !== -1 || !val);
    }

    this.rows = temp;
  }

  filtrarXFecha() {


    if (this.ano == undefined || this.bimestre == undefined) {
      alert('Seleccione un bimestre válido para filtrar las tiendas');
      return;
    }

    this.rows = this.getTiendasXFecha();

  }

  getTiendasXFecha() {

    let temp = this.tempFullRows.filter(t => {
      return t.ano == this.ano && this.convertirMesABimeste(t.mes) == this.bimestre && ((this.plantillaFiltro != undefined) ? this.plantillaFiltro == t.plantilla : true);
    });

    temp = temp.filter(t => t.tienda.toLowerCase().indexOf(this.nombreFiltro) !== -1 || !this.nombreFiltro);

    return temp;

  }

  aplicarFiltros() {
    return this.tempFullRows.filter(t => {
      return t.ano == this.ano && this.convertirMesABimeste(t.mes) == this.bimestre && ((this.plantillaFiltro != undefined) ? this.plantillaFiltro == t.plantilla : true);
    });
  }


  limpiarFiltros() {
    this.rows = this.tempFullRows;
    this.ano = undefined;
    this.bimestre = undefined;
    this.plantillaFiltro = undefined;

  }

  convertirMesABimeste(mes: any) {
    switch (mes) {
      case 0:
      case 1:
        return 1;
      case 2:
      case 3:
        return 2;
      case 4:
      case 5:
        return 3;
      case 6:
      case 7:
        return 4;
      case 8:
      case 9:
        return 5;
      case 10:
      case 11:
        return 6;
    }
  }
}
